<template>
  <div class="dynamicLogs" v-loading="loading">
    <div class="nav-menu">
      <a v-for="(menu, index) in menuList"
        :key="index"
        @click="checkDynamicLogs(index)"
        :class="{'menu-acive': index == activeIndex}">
        {{menu.name}}
      </a>
    </div>
    <div class="logs-containter">
      <!-- 任务动态 -->
      <div v-if="activeIndex == 0">
        <div class="log-container" v-for="(item, index) in dynamicLogsList" :key="index" @click="gotoTaskDetails(item)">
          <div class="time-title">
            <div class="circle"></div>
            <div class="time">{{item.gmtCreate}}</div>
          </div>
          <div class="content">
            <div class="photo">
              <img :src="item.createUser.avatar" v-if="item.createUser.avatar">
              <span v-if="!item.createUser.avatar">{{item.content.substr(0, 1)}}</span>
            </div>
            <div class="title" :title="item.content">{{item.content}}</div>
          </div>
          <!-- 任务名称 -->
          <div class="content-name" :title="item.name" v-if="item.actionEnum != 5 && item.actionEnum != 20">{{item.name}}</div>
          <div class="content-name" v-if="item.actionEnum == 5">从{{item.matterOriginName}}到{{item.matterName}}</div>
          <div class="content-own" v-if="item.actionEnum != 5">
            {{item.matterName}}
            <span v-if="item.dueTime && item.actionEnum != 20">任务时间：{{item.dueTime}}</span>
          </div>
          <!-- 成员头像 -->
          <div class="memeber-image-list" v-if="item.attendees.length > 0 && item.actionEnum != 20">
            <div>
              <div class="multiple-memeber-img" v-for="(item, key) in item.attendees.slice(0,2)" :key="key">
                <img :src="item.avatar" v-if="item.avatar">
                <span v-if="!item.avatar">{{item.name.substr(0, 1)}}</span>
              </div>
            </div>
            <div class="multiple-memeber-img" v-if="item.attendees.length > 2">{{item.attendees.length}}</div>
          </div>
        </div>
      </div>
      <!-- 项目动态 -->
      <div v-if="activeIndex == 1">
        <div class="log-container" v-for="(item, index) in dynamicLogsList" :key="index" @click="gotoMatterDetails(item)">
          <div class="time-title">
            <div class="circle"></div>
            <div class="time">{{item.gmtCreate}}</div>
          </div>
          <div class="content">
            <div class="photo">
              <img :src="item.avatar" v-if="item.avatar">
              <span v-if="!item.avatar">{{item.content.substr(0, 1)}}</span>
            </div>
            <div class="title" :title="item.content">{{item.content}}</div>
          </div>
          <!-- 项目名称 -->
          <div class="content-name" :title="item.matterName">{{item.matterName}}</div>
          <div class="content-own" :title="item.clients">
            {{item.matterNo}}
            <i class="icon ibass ibass-customer" :class="{'no-margin-left': !item.matterNo}" v-if="item.clients.length > 0"></i>
            {{item.clients}}
          </div>
        </div>
      </div>
      <!-- 文档动态 -->
      <div v-if="activeIndex == 2">
        <div class="log-container" v-for="(item, index) in dynamicLogsList" :key="index" @click="goDocumentDetail(item)">
          <div class="time-title">
            <div class="circle"></div>
            <div class="time">{{item.gmtCreate}}</div>
          </div>
          <div class="content">
            <div class="photo">
              <img :src="item.operatorAvatar" v-if="item.operatorAvatar">
              <span v-if="!item.operatorAvatar">{{item.operatorName.substr(0, 1)}}</span>
            </div>
            <div class="title" :title='`${documentActionType[item.actionEnum]} "${item.matterName}"` + (item.path ? `项目文档 ${item.path}` : `项目文档`) '>
              {{item.operatorName}}
              <span>{{documentActionType[item.actionEnum]}}</span>
              <span>"{{item.matterName}}"项目文档</span>
              <span>{{item.path}}</span>
            </div>
          </div>
          <div class="content-name" :title="item.fileName">
            <i
              class="p-document-icon ibass"
              :class="fileProps[item.fileName.split('.').pop()] ? fileProps[item.fileName.split('.').pop()].icon : fileProps.default.icon"
              :style="{color: fileProps[item.fileName.split('.').pop()] ? fileProps[item.fileName.split('.').pop()].color : fileProps.default.color}"
            >
            </i>
            {{item.fileName}}
          </div>
        </div>
      </div>
      <!-- 客户动态 -->
      <div v-if="activeIndex == 3">
        <div class="log-container" v-for="(item, index) in dynamicLogsList" :key="index" @click="gotoCustomerDetails(item)">
          <div class="time-title">
            <div class="circle"></div>
            <div class="time">{{item.gmtCreate}}</div>
          </div>
          <div class="content">
            <div class="photo">
              <img :src="item.operatorAvatar" v-if="item.operatorAvatar">
              <span v-if="!item.operatorAvatar">{{item.operatorName.substr(0, 1)}}</span>
            </div>
            <div class="title">
              {{item.operatorName}}
              <span>{{contactActionType[item.actionEnum]}}</span>
            </div>
          </div>
          <div class="content-name" :title="item.contactName">{{item.contactName}}</div>
          <div class="content-own">客户所属：{{item.contactOwner}}</div>
        </div>
      </div>
      <!-- 加载更多 -->
      <div class="loading-container">
        <span v-if="loading">
            <span>加载中</span>
        </span>
        <span v-else-if="pageCount <= dynamicLogsList.length">
           最近一个月无更多动态
        </span>
        <span v-else class="loading-more" @click="nextPage">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>

import dynamicService from '../../service/dynamic'
import moment from 'moment'
import filePreview from '@/utils/preview'
import clientService from '@/pages/client/service/clientService.js'
import message from '@client/utils/message'

export default {
  name: 'dynamicLogs',
  props: {},
  data () {
    return {
      pageCount: 10,
      activeIndex: 0,
      loading: false,
      taskDynamicParams: {
        pageIndex: 1,
        pageSize: 10,
        moduleEnum: 'TASK'
      },
      //  matterActionType: [
      //    { 9: '添加项目' },
      //    { 10: '完成项目' },
      //    { 11: '删除项目' },
      //    { 12: '搁置项目' },
      //    { 13: '重启项目' },
      //    { 14: '预立项转进行中' }
      //  ],
      //  taskActionType: [
      //   { 4: '添加（复制）任务' },
      //   { 5: '批量复制任务' },
      //   { 6: '完成任务' },
      //   { 7: '删除任务' },
      //   { 8: '重启任务' },
      //   { 20: '批量删除任务' }
      // ],
      documentActionType: {
        1: '上传了文档到',
        2: '删除了文档',
        3: '编辑了文档',
        15: '新建了文档到',
        16: '恢复删除了文档'
      },
      contactActionType: {
        17: '新增了客户',
        18: '删除了客户',
        19: '编辑了客户信息'
      },
      moduleEnumArr: ['TASK', 'MATTER', 'DOCUMENT', 'CONTACT'],
      menuList: [ { name: '任务动态' }, { name: '项目动态' }, { name: '文档动态' }, { name: '客户动态' } ],
      dynamicLogsList: [],
      fileProps: {
        'docx': {
          icon: 'ibass-filetype-doc',
          color: '#0a96e5'
        },
        'doc': {
          icon: 'ibass-filetype-doc',
          color: '#0a96e5'
        },
        'pdf': {
          icon: 'ibass-filetype-pdf',
          color: '#e3574d'
        },
        'xlsx': {
          icon: 'ibass-filetype-excel',
          color: '#1c7044'
        },
        'pptx': {
          icon: 'ibass-filetype-ppt',
          color: '#e3574d'
        },
        'key': {
          icon: 'ibass-keynote',
          color: '#1a9bf7'
        },
        'numbers': {
          icon: 'ibass-numbers',
          color: '#08ad00'
        },
        'pages': {
          icon: 'ibass-pages',
          color: '#ff8403'
        },
        'jpg': {
          icon: 'ibass-filetype-image',
          color: '#07cfda'
        },
        'png': {
          icon: 'ibass-filetype-image',
          color: '#07cfda'
        },
        'jpeg': {
          icon: 'ibass-filetype-image',
          color: '#07cfda'
        },
        'bmp': {
          icon: 'ibass-filetype-image',
          color: '#07cfda'
        },
        'gif': {
          icon: 'ibass-filetype-image',
          color: '#07cfda'
        },
        'default': {
          icon: 'ibass-filetype-default',
          color: '#cdc9c5'
        }
      }
    }
  },
  created () {
    this.getTaskDynamicLists()
  },
  methods: {
    // 点击加载更多
    checkDynamicLogs (index) {
      this.activeIndex = index
      this.taskDynamicParams.pageIndex = 1
      this.dynamicLogsList = []
      this.taskDynamicParams.moduleEnum = this.moduleEnumArr[index]
      this.getTaskDynamicLists()
      this.getStatisticsNum(index)
    },
    // 获取动态下的列表
    getTaskDynamicLists () {
      let _this = this
      _this.loading = true
      dynamicService.getTaskDynamicLists(this.taskDynamicParams).then(response => {
        if (response.isSuccess) {
          let data = response.data.entities || []
          _this.pageCount = response.data.entityCount
          data.forEach(function (item) {
            item['gmtCreate'] = moment(item.gmtCreate).format('YYYY-MM-DD HH:mm:ss')
            if (item['dueTime']) {
              item['dueTime'] = item.dayType === 1 ? moment(item.dueTime).format('YYYY-MM-DD') : moment(item.dueTime).format('YYYY-MM-DD HH:mm:ss')
            }
            // 对项目中的客户名称进行处理
            if (item.clients !== undefined) {
              let clientsArr = []
              item.clients.forEach(function (value) {
                clientsArr.push(value.contactName)
              })
              item.clients = clientsArr.join(',')
            }
          })
          _this.dynamicLogsList = _this.dynamicLogsList.concat(data)
          _this.loading = false
        } else {
          _this.loading = false
          _this.$message(response.resultMsg)
        }
      })
    },
    // 神策统计
    getStatisticsNum (index) {
      let str = ''
      switch (index) {
        case 0:
          str = '切换任务动态_动态/工作台模块'
          break
        case 1:
          str = '切换项目动态_动态/工作台模块'
          break
        case 2:
          str = '切换文档动态_动态/工作台模块'
          break
        case 3:
          str = '切换客户动态_动态/工作台模块'
          break
        default:
          str = ''
      }
      this.$analysis.track(str)
    },
    nextPage () {
      this.taskDynamicParams.pageIndex += 1
      this.getTaskDynamicLists()
    },
    // 客户跳转
    gotoCustomerDetails (item) {
      if (item.actionEnum === 18) {
        this.$message.error('该客户已被删除')
      }
      clientService.queryRightByPermission('CON:contact.contactSelf:enter', item.objectId).then(res => {
        if (Object.values(res)[0]) {
          message.checkDetail({ customerId: item.objectId })
        } else {
          this.$message.error('该客户已被删除或者无查看权限，请检查后重试')
        }
      })
    },

    // 任务跳转
    gotoTaskDetails (item) {
      window.parent.postMessage({
        action: 'fromWorkFlatTaskDetails',
        data: {
          objectId: item.objectId,
          matterId: item.matterId,
          actionEnum: item.actionEnum
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    },
    // 项目跳转
    gotoMatterDetails (item) {
      window.parent.postMessage({
        action: 'fromWorkFlatMatterDetails',
        data: {
          matterId: item.matterId
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    },
    async getDocumentSize (item) {
      const { id, fileName, path, repoId, objectId } = item
      let params = { fileName, path: (path || '') + '/', repoId, fileId: objectId }
      const { data, isSuccess } = await dynamicService.getDocumentSize(id, params)
      if (isSuccess) {
        return data
      } else {
        return false
      }
    },
    // 文档跳转
    async goDocumentDetail (item) {
      // size丢失，跳转前获取size
      let size = item.size
      if (size === 0) {
        size = await this.getDocumentSize(item)
      }

      let params = {
        fileId: item.objectId,
        matterId: '',
        repoId: item.repoId,
        filePath: (item.path || '') + '/' + item.fileName,
        name: item.fileName,
        size: size,
        className: filePreview.queryDocumentType(item.fileName)
      }
      filePreview.preview(params)
    }
  }
}
</script>

<style lang="stylus">
  .dynamicLogs{
    background-color: #ffffff;
    // width: 720px;
    padding-bottom: 100px;
    min-height: 400px;
  }
  .nav-menu{
    padding-top: 24px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    font-size 12px
    text-align center
  }
  .nav-menu a{
    display: inline-block;
    width: 48px;
    margin: 0 24px;
    border-bottom: 2px solid #fff;
    height: 28px;
    line-height: 28px;
  }
  .nav-menu a:hover{
    font-weight 500
    border-color #EE720A
    color #EE720A
  }
  .nav-menu .menu-acive{
    font-weight: 500;
    border-bottom: 2px solid #EE720A;
    color: #EE720A;
  }
  .logs-containter{
    margin-top: 33px;
    padding-left: 35px;
  }
  .log-container{
    margin-top: 16px;
    position: relative;
    border-bottom: 1px solid #ECECEC;
    padding-bottom: 16px;
    cursor: pointer;
  }
  .time-title{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 8px;
  }
  .time{
    padding-left 8px
    font-size: 12px;
    color: #A9A9A9;
  }
  .circle{
    width 9px
    height 9px
    background-color #07CFDA
    border-radius 50%
  }
  .content{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 17px;
  }
  .content .photo{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    background: #fdba78;
    font-size: 18px;
    text-align: center;
    line-height: 32px;
    color: #fff;
  }
  .content .photo img{
    width 100%
  }
  .content .title{
    width: 520px;
    margin-left 16px
    word-break break-all
    font-size: 12px;
    color: #000000;
    text-overflow ellipsis;
    white-space nowrap;
    overflow hidden;
    // cursor pointer;
  }
  .content .title span{
    margin-left 8px
    color: #666666;
  }
  .content-name{
    width: 520px;
    margin-top: 8px;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    padding-left: 65px;
    text-overflow ellipsis;
    white-space nowrap;
    overflow hidden;
  }
  .content-own{
    height: 17px;
    font-size: 12px;
    line-height: 17px;
    padding-left: 65px;
    color: #8590A6;
    margin-top: 7px;
    text-overflow ellipsis;
    white-space nowrap;
    overflow hidden;
    width: 520px;
  }
  .content-own .icon{
    margin-left: 25px;
    margin-right: 5px
  }
  .no-margin-left{
    margin-left: 0 !important;
  }
  .content-own span{
    padding-left: 25px;
  }
  .log-container .memeber-image-list{
    width: 80px;
    height: 34px;
    position: absolute;
    right: 24px;
    bottom: 24px;
  }
  .memeber-image-list .multiple-memeber-img {
    width: 32px;
    height: 32px;
    float: left;
    margin-right: -8px;
    border-radius: 50%;
    overflow: hidden;
    background: #B6BCCA;
    box-sizing: content-box;
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
  }
  .memeber-image-list .multiple-memeber-img img{
    width: 100%;
  }
  .loading-container
    margin-top 20px
    text-align center
    font-size 14px
    color #8590a6
    .loading-more
      cursor pointer
    .demo-spin-icon-load
      animation ani-demo-spin 1s linear infinite
  .no-show-logs{
    text-align: center;
    padding: 100px 0;
  }
</style>
